import { Plugin } from "ckeditor5";
import SummarizeResponseEditing from "./summarizeResponseEditing";
import SummarizeResponseUI from "./summarizeResponseUI";

export default class SummarizeResponse extends Plugin {
  public static get requires() {
    return [SummarizeResponseEditing, SummarizeResponseUI];
  }

  public static get pluginName(): string {
    return "SummarizeResponse";
  }
}
